/**
 * "Automatisk" (SPEC-auto-booking.md D8): the one badge for what the automatic
 * booking policy did. A plan carries it when the policy created it
 * (actor 'policy'); a supplier invoice when an auto_booked decision exists
 * (the DTO's auto_booked_at). The tone is StatusBadge's `info`.
 */
export const AUTO_BOOKING_BADGE = { label: 'Automatisk', tone: 'info' };

export function autoBookingPlanBadge(plan) {
  return plan?.actor === 'policy' ? AUTO_BOOKING_BADGE : null;
}

export function autoBookingInvoiceBadge(invoice) {
  return invoice?.auto_booked_at ? AUTO_BOOKING_BADGE : null;
}

/** The plans list's tab filter, narrowed to the policy's plans on request. */
export function filterPlans(plans, { tab, onlyPolicy = false }) {
  return (plans || [])
    .filter((p) => (tab === 'active' ? p.status === 'active' : ['completed', 'cancelled'].includes(p.status)))
    .filter((p) => !onlyPolicy || p.actor === 'policy');
}
